/*
*###############################################################################
*Module Name                   : DPTextBox.js                                  #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Tuesday, August 24th 2021, 1:47:16 pm         #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState } from 'react';
import { Row, Label, Input, Button } from "reactstrap"
import DPDropDown from "framework/components/DPDropDown"
import Select from "react-select"
import { Link } from 'react-router-dom';

const DPTextBoxWithDropDown = ({ rowClass, labelText, textType, value, onChange, placeholder, textAlign, disabled, onKeyPress, onBlur, id,
    selectedGroup, optionGroup, onChangeDrop, inputId, onClickBtn, loadRefTransacton, refButtonClickValue }) => {

    return (
        <Row className={rowClass}>
            <Label
                htmlFor="example-text-input"
                className="col-md-3 col-form-label-sm"
            >
                {labelText}
            </Label>
            <div className="col-md-9">
                <Row>
                    <div className="col-md-5" style={{ marginLeft: '6px', marginRight: '-23px', height: '1px' }}>
                        <DPDropDown
                            optionGroup={optionGroup}
                            selectedGroup={selectedGroup}
                            onChange={onChangeDrop}
                            disabled={disabled}
                            iconShow={true}
                            labelHide={true}
                        />
                    </div>
                    <div className="col-md-5">
                        <Input
                            className="form-control-sm mx-2"
                            type={textType}
                            value={value}
                            onChange={onChange}
                            onKeyPress={onKeyPress}
                            onBlur={onBlur}
                            onFocus={(e) => {
                                e.target.select()
                            }}
                            placeholder={placeholder}
                            // style={{ textAlign: textAlign ? textAlign : 'left', textAlign: 'left', height: '37px' }}
                            disabled={disabled}
                            id={id}
                        />
                    </div>
                    <div className="col-md-2 d-flex align-items-end" >
                        <Button
                            onClick={onClickBtn}
                            color="success"
                            className="btn-sm"
                            disabled={disabled}
                            style={{ marginRight: '8px' }}
                            size="sm"
                        >
                            <i
                                className="mdi mdi-search-web"
                                style={{ fontSize: "12px" }}
                            ></i>
                        </Button>
                        {loadRefTransacton ?

                            <Link to={refButtonClickValue} target="_blank">
                                <Button
                                    color="primary"
                                    className="btn-sm"
                                    style={{ marginRight: '8px' }}
                                    size="sm"
                                >
                                    <i
                                        className="mdi mdi-notebook-plus"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </Button></Link>

                            : null}
                    </div>
                </Row>
            </div>
        </Row>
    );
}

export default DPTextBoxWithDropDown;